import { render, staticRenderFns } from "./DocflowPlan.vue?vue&type=template&id=4babc9a4&scoped=true&"
import script from "./DocflowPlan.vue?vue&type=script&lang=js&"
export * from "./DocflowPlan.vue?vue&type=script&lang=js&"
import style0 from "./DocflowPlan.vue?vue&type=style&index=0&id=4babc9a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4babc9a4",
  null
  
)

export default component.exports